// export service from services folder here
export { ParameterService } from './parameter.service'
export { DocumentTemplateService } from './document-template.service'
